import styled, { css } from "styled-components";
import PropTypes from "prop-types";

const ICON_OFFSET = "var(--dui-size-space-20x)";

const Placeholder = styled.span`
  ${({ hasRightIcon, hasLeftIcon, hasLabel, isRequired }) => css`
    ${isRequired &&
    css`
      &:after {
        color: var(--dui-color-red-500);
        content: " *";
      }
    `};
    box-sizing: border-box;
    color: var(--dui-color-gray-600);
    display: block;
    font-family: var(--dui-font-family);
    font-size: var(--dui-size-font-md);
    left: 1px;
    overflow: hidden;
    padding: ${hasLabel
      ? "var(--dui-size-space-7x) var(--dui-size-space-6x) var(--dui-size-space-7x) var(--dui-size-space-6x)"
      : "var(--dui-size-space-10x) var(--dui-size-space-6x) var(--dui-size-space-4x) var(--dui-size-space-6x)"};
    padding-left: ${hasLeftIcon && css`calc(5 * var(--dui-size-space-7x))`};
    padding-right: ${hasRightIcon ? ICON_OFFSET : undefined};
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    top: 1px;

    transition: transform var(--dui-duration-3x),
      font-size var(--dui-duration-3x), opacity var(--dui-duration-3x);

    white-space: nowrap;
    width: 100%;
  `}
`;

Placeholder.defaultProps = {
  hasRightIcon: false,
  hasLabel: false,
  isRequired: false,
};

Placeholder.propTypes = {
  /** An **optional** prop to flag the Placeholder component to set spacing when right icon is shown */
  hasRightIcon: PropTypes.bool,
  /** An **optional** prop to flag the Placeholder component to set spacing when left icon is shown */
  hasLeftIcon: PropTypes.bool,
  /** An **optional** prop to flag the Placeholder component to set spacing when Label is also being shown */
  hasLabel: PropTypes.bool,
  /** An **optional** prop to flag the Placeholder component to append * after the label text */
  isRequired: PropTypes.bool,
};

export default Placeholder;
